import { fetchApi } from '@/config/axiosSetting.ts';
import { FileStatusCountsQueryResponseType } from '@/modules/Dashboard/queries/fileStatusCounts/fileStatusCountsQuery.type.ts';

export const fileStatusCountsQueryFunction =
  (): Promise<FileStatusCountsQueryResponseType> =>
    fetchApi.get('homepage/files_current_numbers/');
